import { useClaims } from '@auth/useClaims';
import { adviseurApi } from '@services/crm-internal/service';
import { useQuery } from '@tanstack/vue-query';
import { computed } from 'vue';

export function useAdviseurs() {
  const claims = useClaims();

  return useQuery({
    enabled: computed(() => claims.value.isInternal),
    queryFn: () => adviseurApi.tussenpersonenGet(),
    queryKey: ['adviseurData'],
    select: ({ data }) => data?.result?.filter(({ id }) => id > 0),
  });
}
